module.exports = {"id":"200630","name":"James Forrest","rating":"75","photo":"./data/images/photos/2/200630.png","club":{"name":"Celtic","logo":"./data/images/clubs/Celtic.png"},"positions":["MD"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JamesForrest0.json
// module id = 1894
// module chunks = 0